import { render, staticRenderFns } from "./addVendorReqeuest.vue?vue&type=template&id=752b6a59&"
import script from "./addVendorReqeuest.vue?vue&type=script&lang=js&"
export * from "./addVendorReqeuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCombobox,VDivider,VSimpleTable})
